
<p-toast></p-toast>
<i class="pi pi-home" style="font-size: 2rem;margin-left:20px;cursor:pointer;" (click)="goHome()"></i>
<i class="pi pi-replay" style="font-size: 2rem;margin-left:20px;cursor:pointer;" (click)="goToRetests()"></i>

<router-outlet></router-outlet>